// extracted by mini-css-extract-plugin
export default {"card":"card_card__sZ8O2","heading":"card_heading__+w6VO","normalHeading":"card_normalHeading__xg9+v","smallText":"card_smallText__QVp9g","price":"card_price__rsmnn"};